// extracted by mini-css-extract-plugin
module.exports = {"badge":"styles_badge__OWSJD"};